import { createContext } from 'react';
import { type SiteNotice } from '@/app/config/global';

export interface SiteNoticeContextValue {
  readonly siteNotices: readonly SiteNotice[];
  readonly showTechnicalIssuesNotice: () => void;
  readonly showNoAccessNotice: () => void;
}

export const SiteNoticeContext = createContext<SiteNoticeContextValue>({
  siteNotices: [],
  showTechnicalIssuesNotice: () => {
    /* do nothing */
  },
  showNoAccessNotice: () => {
    /* do nothing */
  },
});
